import React from 'react'
import { useTypewriter, Cursor } from "react-simple-typewriter";
import Media from './Media';

const LeftBanner = () => {
    const [text] = useTypewriter({
      words: ["FrontEnd Expert.", "React Specialist.", "Tech Explorer.","JavaScript Ninja."],
      loop: true,
      typeSpeed: 20,
      deleteSpeed: 10,
      delaySpeed: 2000,
    });
  return (
    <div className="w-full lgl:w-1/2 flex flex-col gap-20">
      <div className="flex flex-col gap-5">
        {/* <h4 className=" text-lg font-normal">Hola Amingos 👀🙋‍♂️  </h4> */}
        <h1 className="text-2xl font-bold text-white sm:text-4xl">
          Hi, I'm <span className="text-designColor capitalize">Vikas Mishra</span>
        </h1>
        <h2 className="text-3xl font-bold text-white">
          a <span>{text}</span>
          <Cursor
            cursorBlinking="false"
            cursorStyle="|"
            cursorColor="cyan"
          />
        </h2>
        <p className="text-base font-bodyFont leading-6 tracking-wide">
        "I build robust, efficient, and user-focused web solutions. A champion of Agile practices, I blend strong design principles, expertise in JavaScript and ReactJS, and a keen eye for UX enhancements to deliver seamless digital experiences. Proficient in modern web technologies and design patterns, I thrive on creating scalable, high-performance interfaces."
        </p>
      </div>
     {/* Media */}
     <Media />
    </div>
  );
}

export default LeftBanner